/** ערוצי תוכן למשתמרת — חייב להתאים ל-backend/src/data/lessonChannels.js */
export const LESSON_CHANNELS = [
  { id: 'daf_yomi_shmerler', label: "דף היומי — ר' חיים שמרלר", ivrPath: '77/1/1' },
  { id: 'daf_yomi_sikum', label: 'דף היומי — סיכומים', ivrPath: '77/1/1' },
  { id: 'daf_yomi_tovei', label: 'דף היומי — טובי מגידי השיעורים', ivrPath: '77/1/1' },
  { id: 'shinun_levi', label: 'השיעור היומי בחברותא — האחים לוי', ivrPath: '77/2/1' },
  { id: 'shinun_binet', label: 'השיעור היומי הקצר — הרב עמרם בינעט', ivrPath: '77/2/1' },
  { id: 'shinun_blik', label: 'א בליק אויפן בלעט', ivrPath: '77/2/1' },
  { id: 'shinun_special', label: 'שיעורים מיוחדים והודעות', ivrPath: '77/2/1' },
  { id: 'shinun_magash', label: 'שיעורים ממג״ש בחצר קדשינו', ivrPath: '77/2/1', submenu: true },
  { id: 'all_lessons', label: 'כל השיעורים', ivrPath: '77/5' },
  { id: 'dibrot_zya', label: 'דברות קודש — רבינו זי״ע', ivrPath: '77/6/1' },
  { id: 'dibrot_shlita', label: 'דברות קודש — רבינו שליט״א', ivrPath: '77/6/1' },
  { id: 'maamadim', label: 'מעמדי משתמרת', ivrPath: '77/6/2' },
];

export const SHINUN_MAGASH_PREFIX = 'shinun_magash_';

export function isShinunMagashChannel(channel) {
  const ch = String(channel || '');
  return ch.startsWith(SHINUN_MAGASH_PREFIX) && ch.length > SHINUN_MAGASH_PREFIX.length;
}

/** טאבי תוכן רגילים — בלי אב מג״ש (מנוהל במסך נפרד) */
export function contentLessonChannels() {
  return LESSON_CHANNELS.filter((c) => !c.submenu);
}

const systemId = String(process.env.REACT_APP_SYSTEM_ID || '').replace(/^["']|["']$/g, '').trim();
export const IS_MISHTAMERET = systemId === 'waiting_client';
